import PropTypes from 'prop-types';
import React, { Component } from 'react';

class DailyTasksCompleteList extends Component {
  static propTypes = {
    currentProjectId: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
  }

  render() {
    return (
      <div className="row tab-content-wrapper">
        <div className="col-md-12 project-default-left-col">
          <h2>
            <span>{/* Report Title Goes Here*/} placeholder</span>
          </h2>
          <div className="row">
            report visualization goes here
          </div>
        </div>
      </div>
    );
  }
}

export default DailyTasksCompleteList;



// WEBPACK FOOTER //
// ./src/views/ProjectSettings/DailyTasksComplete/DailyTasksComplete.js